document.querySelectorAll<HTMLElement>('.carrot-google-map').forEach((map) => {
  if (!map.getAttribute('data-interactive')) {
    return;
  }

  let interactionHasTriggered = false;

  map.addEventListener('mouseenter', () => {
    if (!window.GOOGLE_MAPS_ROTATING_KEY) {
      console.warn('Google API key not found');
      return;
    }

    const image = map.querySelector('img');

    if (!image || interactionHasTriggered) {
      return;
    }

    interactionHasTriggered = true;

    const zoom = map.getAttribute('data-zoom') || 14;
    const address = map.getAttribute('data-address');

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.google.com/maps/embed/v1/place?key=${window.GOOGLE_MAPS_ROTATING_KEY}&q=${encodeURIComponent(address ?? '')}&zoom=${zoom}`;
    iframe.title = `Interactive Google Map for ${address}`;

    /*
     * Overlay the interactive iframe on top of the static image rather than
     * replacing it. The image stays in normal flow as the block's size
     * reference, so its (responsive) width and height are preserved with no
     * value to measure or lock in — the map keeps adapting to viewport
     * resizes and device rotation for free. The image is faded out but left
     * in the DOM on purpose: removing it leaves the block with no in-flow
     * content, collapsing it to 0 width inside shrink-to-fit parents like the
     * Spark contact section's centered flex group (the original hover bug).
     */
    map.style.position = 'relative';
    iframe.style.cssText = `
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border: none;
      opacity: 0;
      transition: opacity 600ms ease;
    `;
    image.style.transition = 'opacity 600ms ease';
    image.style.pointerEvents = 'none';

    map.appendChild(iframe);

    iframe.addEventListener('load', () => {
      setTimeout(() => {
        iframe.style.opacity = '1';
        image.style.opacity = '0';
      }, 250);
    });
  });
});
